function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-27 -4)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#DD5860",
  d: "M74.203 6.155l41.189 85.583a3 3 0 0 1-2.703 4.301H30.31a3 3 0 0 1-2.703-4.3L68.797 6.154a3 3 0 0 1 5.406 0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 30,
  x: 70,
  y: 36,
  fill: "#FFF",
  fillRule: "nonzero",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 5,
  x: 69,
  y: 76,
  fill: "#FFF",
  fillRule: "nonzero",
  rx: 2.5
}));

var SvgAlertIco = function SvgAlertIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 93,
    viewBox: "0 0 89 93",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlertIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert-ico.f7541e33.svg";
export { ForwardRef as ReactComponent };